/* sections/tutorial.liquid — building the player on demand.

   The section renders the post's featured image with the theme's play badge over it and
   parks the embed in a <template>. Nothing third-party loads until someone asks for it,
   which is the point: a tutorial page otherwise pays for a Youtube player it may never
   show. The same markup sits in a <noscript>, so a browser that never runs this file
   gets the video anyway — the facade below is progressive enhancement, not the only way
   in.

   No custom element and no section event: the control is one button and the work is one
   swap, so a delegated listener on the document is the whole of it. That also survives
   the theme editor re-rendering the section, which would strip a listener bound at load
   to an element that no longer exists. */

(function () {
    'use strict';

    /* Youtube and Vimeo both take autoplay in the query string, and both need it: the
       click that asked for the video is the click that should start it, and a player
       built cold sits on its own poster waiting for a second one. Appended rather than
       set, so a src that already carries parameters keeps them. */
    function withAutoplay(src) {
        if (!src || src.indexOf('autoplay=') !== -1) return src;
        return src + (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
    }

    function play(facade) {
        var inner = facade.parentNode;
        if (!inner) return;

        var template = inner.querySelector('[data-tutorial-embed]');
        if (!template) return;

        var embed = template.content.cloneNode(true);

        var iframe = embed.querySelector('iframe');
        if (iframe) {
            iframe.setAttribute('src', withAutoplay(iframe.getAttribute('src')));
            /* The embed is the blog editor's own HTML, so it may or may not carry these.
               Both are what makes the player usable once it is in a 600px box. */
            iframe.setAttribute('allowfullscreen', '');
            if (!iframe.getAttribute('allow')) {
                iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
            }
        }

        /* A <video> cannot be started from the markup the same way — autoplay on a file
           with sound is refused by every browser. Held and played from the click instead,
           which is the gesture that permits it. */
        var video = embed.querySelector('video');
        if (video) {
            video.setAttribute('controls', '');
            video.setAttribute('playsinline', '');
        }

        /* Replaced rather than hidden, so the poster stops being focusable and the
           template is spent. The <noscript> beside it is inert in a scripted browser. */
        inner.replaceChild(embed, facade);

        if (video && typeof video.play === 'function') {
            var started = video.play();
            /* Rejects when the browser refuses the gesture — the controls are already
               there, so the viewer presses play themselves. Caught so it is not an
               unhandled rejection in the console. */
            if (started && typeof started.catch === 'function') started.catch(function () {});
        }
    }

    document.addEventListener('click', function (event) {
        var facade = event.target.closest ? event.target.closest('[data-tutorial-play]') : null;
        if (!facade) return;
        event.preventDefault();
        play(facade);
    });
})();
